module.exports = __webpack_public_path__ + "static/media/logo-devaria-01.bab29f41.svg";